import { GetServerSideProps, NextPage } from 'next';

import { LoginPage } from '~/modules/login';

import VmcoreErpLandingPage from './_landing/vmcore-erp';

const VMCORE_MARKETING_HOST = 'vmcore-erp.com';

type IndexPageProps = {
  showVmcoreLanding?: boolean;
  layoutMode?: 'default' | 'none';
};

function normalizeHost(host?: string | string[]): string {
  return String(Array.isArray(host) ? host[0] : host || '')
    .trim()
    .toLowerCase()
    .replace(/^www\./, '')
    .split(':')[0];
}

const Index: NextPage<IndexPageProps> = ({ showVmcoreLanding }) => {
  if (showVmcoreLanding) {
    return <VmcoreErpLandingPage />;
  }

  return <LoginPage />;
};

export const getServerSideProps: GetServerSideProps<IndexPageProps> = async (
  context
) => {
  const forwardedHost = context.req.headers['x-forwarded-host'];
  const host = forwardedHost || context.req.headers.host;
  const normalizedHost = normalizeHost(host);

  if (
    normalizedHost === VMCORE_MARKETING_HOST ||
    context.query.preview === 'vmcore'
  ) {
    return {
      props: {
        showVmcoreLanding: true,
        layoutMode: 'none',
      },
    };
  }

  return {
    props: {
      showVmcoreLanding: false,
      layoutMode: 'default',
    },
  };
};

export default Index;
